import { IdPlrcNavigation } from "../../interfaces/serviceModels/IRequestJSON";
import { setPLRCCONTENTOBJECT } from "../constants/plrcContentObject.types";

export const setPlrcContentObject = (plrcObject: IdPlrcNavigation) => {
  return {
    type: setPLRCCONTENTOBJECT,
    payload: plrcObject,
  };
};
